import React from 'react';
import { MuiThemeProvider, Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import createMuiTheme from '@material-ui/core/styles/createMuiTheme';

const useStyles = makeStyles((theme) => {
  return {
    buttonMinimal: {
      padding: theme.spacing(1, 2),
      minWidth: 100,
    },
  };
});

const createCustomColorTheme = (color) => {
  return createMuiTheme(
    {
      palette: {
        secondary: {
          main: color,
        },
      },
      overrides: {
        MuiTypography: {
          subtitle2: {
            fontSize: [ 12, '!important' ],
          },
        },
      },
    },
  );
};

const AppButtonMain = (props) => {
  const classes = useStyles();
  const customTheme = createCustomColorTheme(props.color || '#a0d012');

  return (
    <MuiThemeProvider theme={ customTheme }>
      <Button
        style={ { color: '#0bae0e' === props.color ? 'white' : '' } }
        disableElevation
        className={ classes.buttonMinimal }
        size='small'
        disabled={ props.disabled }
        onClick={ props.onClick }
        color='secondary'
        variant='contained'
      >
        <Typography variant='subtitle2'>
          {props.text}
        </Typography>
      </Button>
    </MuiThemeProvider>
  );
};

export default AppButtonMain;
